"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdminPermission = exports.AdminPermissions = void 0;
exports.AdminPermissions = [
    'become_user',
    'ip_blacklists',
    'featured_users',
    'feature_flags',
    'hevy_trainer',
    'user_account_management',
    'import_strong_csv',
    'community_management',
];
const isAdminPermission = (permission) => {
    if (!permission || typeof permission !== 'string') {
        return false;
    }
    return exports.AdminPermissions.includes(permission);
};
exports.isAdminPermission = isAdminPermission;
